import { Popover } from "@mui/material";
import React, { useState, useContext } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify from "../../../Helpers/ToastNotification";
import {
  SanjeevaniDepositStatus,
  SanjeevaniWithdrawStatus,
  SuvidhaDepositStatus,
  SuvidhaWithdrawStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  UpdateStatusByAdmin,
  UpdateWithdrawStatusByAdmin,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";
import "../ApprovalModal/ApprovalModal.css";
import { SanjeevaniModules } from "../../../Helpers/Enums/Modules";
import { getContext } from "../../../Helpers/Context/Context";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { AppModules } from "../../../Helpers/Enums/AppModules";

const useGapStyles = makeStyles({
  paper: {
    marginTop: "-1rem",
  },
});

const SanjeevaniDepositeModal = ({
  open,
  anchorEl,
  handleClose,
  module,
  appModule,
  sendMemberId,
}) => {
  const [hideShowComment, setHideShowComment] = useState(true);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [error, setError] = React.useState<any>({});
  const navigate = useNavigate();
  const context = getContext();
  let UserName = context.FirstName + " " + context.MiddleName;
  let MemberId = context.MemberId;
  const [errorRemark, setErrorRemark] = useState("");
  const [reviewerRemark, setReviewerRemark] = useState("");

  const { state } = useLocation();
  const currentStatus =
    state !== null && state.currentStatus ? state.currentStatus : 0;
  const RequestId = state !== null && state.RequestId ? state.RequestId : 0;
  const classes = useGapStyles();
  const Id = state ? state.Id : null;
  const onChange = (event, value) => {
    if (event === "comment") {
      setComment(value.target.value);
      setErrorRemark("");
    } else if (event === "approve") {
      setApprove(value);
      setReject(!value);
      setHideShowComment(true);
      setComment("");
    } else if (event === "reject") {
      setReject(value);
      setApprove(!value);
      setHideShowComment(false);
    } else if (event === "reviewerRemark") {
      setReviewerRemark(value);
      setHideShowComment(false);
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    setErrorRemark("");
    if (approve == false && reject == false) {
      notify(1, "Select at least one checkbox.");
      // errorObj = { approve: "Select at least one checkbox." };
      return;
    }

    // if (approve == false) {
    //   if (comment == "") {
    //     errorObj = {
    //       ...errorObj,
    //       [comment]: "This field is required",
    //     };
    //   } else if (comment.length > 100) {
    //     errorObj = {
    //       ...errorObj,
    //       comment: "Comment should be less than 100 characters",
    //     };
    //   }
    // }
    if (reject) {
      if (!comment.trim()) {
        setErrorRemark("Remark is required");
        return;
      }
    }

    setError(errorObj);
   
    if (Object.keys(errorObj).length === 0) {
      showLoader();
      // Only for deposit Sanjevani and suvidha
      if (
        currentStatus === SanjeevaniDepositStatus.Deposit_Approval_Pending ||
        currentStatus === SuvidhaDepositStatus.SU_Deposit_Approval_pending
      ) {
        let requestParams = {
          StatusId: 0,
          RequestId: RequestId,
          MemberId: Id ? Id : sendMemberId,
          CreatedBy: context.Id,
          YojnaType:
            appModule === AppModules.SuvidhaYojna
              ? "SuvidhaYojna"
              : "SanjivaniYojna",
          ...(reject === true && { Remark: comment }),
        };

        if (module === SanjeevaniModules.ModuleApproval) {
          // const Admin = context.loggedInAs?.value === RoleEnum.Admin;
          if (appModule === AppModules.SanjeevaniYojana && approve === true) {
            requestParams.StatusId =
              SanjeevaniDepositStatus.FD_Number_genrator_pending;
          } else if (
            appModule === AppModules.SuvidhaYojna &&
            approve === true
          ) {
            requestParams.StatusId =
              SuvidhaDepositStatus.SU_FD_Number_genrator_pending;
          }

          if (appModule === AppModules.SanjeevaniYojana && reject === true) {
            requestParams.StatusId = SanjeevaniDepositStatus.Deposit_Rejected;
          } else if (appModule === AppModules.SuvidhaYojna && reject === true) {
            requestParams.StatusId = SuvidhaDepositStatus.SU_Deposit_Rejected;
          }
        }

        const res = await APICall(UpdateStatusByAdmin, requestParams);
        if (res.Message === "Success") {
          let message = approve ? "Approve" : reject ? "Reject" : "";
          notify(0, `Request ${message} Successfully`);
          handleClose();
          navigate(
            appModule === AppModules.SanjeevaniYojana
              ? "/SanjivaniDashboard"
              : "/SuvidhaDashboard"
          );
        } else if (res.Message === "Something Went Wrong.") {
          notify(1, `${res.Message}`);
        }
      } else if (
        currentStatus ===
          SanjeevaniWithdrawStatus.FD_Withdraw_Approval_pending ||
        currentStatus === SuvidhaWithdrawStatus.SU_FD_Withdraw_Approval_pending
      ) {
        let requestParams = {
          StatusId: 0,
          RequestId: RequestId,
          MemberId: Id ? Id : sendMemberId,
          CreatedBy: context.Id, // user ki Id
          YojnaType:
            appModule === AppModules.SuvidhaYojna
              ? "SuvidhaYojna"
              : "SanjivaniYojna",
          ...(reject === true && { Remark: comment }),
        };
        // requestParams.Comment = comment;
        if (module === SanjeevaniModules.ModuleApproval) {
          // const Admin = context.loggedInAs?.value === RoleEnum.Admin;
          if (appModule === AppModules.SanjeevaniYojana && approve === true) {
            requestParams.StatusId =
              SanjeevaniWithdrawStatus.FD_Withdraw_Number_genrator_pending;
          } else if (
            appModule === AppModules.SuvidhaYojna &&
            approve === true
          ) {
            requestParams.StatusId =
              SuvidhaWithdrawStatus.SU_FD_Withdraw_Number_genrator_pending;
          }

          if (appModule === AppModules.SanjeevaniYojana && reject === true) {
            requestParams.StatusId =
              SanjeevaniWithdrawStatus.FD_Withdraw_Rejected;
          } else if (appModule === AppModules.SuvidhaYojna && reject === true) {
            requestParams.StatusId =
              SuvidhaWithdrawStatus.SU_FD_Withdraw_Rejected;
          }
        }
        // Only for withdraw Sanjevani and suvidha
        const res = await APICall(UpdateWithdrawStatusByAdmin, requestParams);
        if (res.Message === "Success") {
          let message = approve ? "Approve" : reject ? "Reject" : "";
          notify(0, `Request ${message} Successfully`);
          handleClose();
          navigate(
            appModule === AppModules.SanjeevaniYojana
              ? "/SanjivaniDashboard"
              : "/SuvidhaDashboard"
          );
        } else if (res.Message === "Something Went Wrong.") {
          notify(1, `${res.Message}`);
        }
      }

      hideLoader();
    }
  };

  return (
    <Popover
      id={"id"}
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        paper: classes.paper,
      }}
      className=""
    >
      <div className="p-3 verify-modal">
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="approve"
                title="Approve"
                onChange={onChange}
                checked={approve}
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="reject"
                title="Reject"
                onChange={onChange}
                checked={reject}
              />
            </div>
          </div>
          <br />
          {!hideShowComment && (
            <div className="row pb-3">
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group">
                  <label>Reviewer Name</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    value={UserName}
                  />
                </div>
                <div className="form-group">
                  <label>Reviewer Remark</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={comment}
                    onChange={(val: any) => onChange("comment", val)}
                    textArea={true}
                  />
                  {errorRemark && <p className="text-danger">{errorRemark}</p>}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent
            icon={""}
            className="btn btn-cancel"
            style={{ marginLeft: 5 }}
            onClick={handleClose}
            value={"Cancel"}
            id={"cancelBtn"}
          />
          <ButtonComponent
            icon={""}
            value={"Submit"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={onSubmit}
          />
        </div>
      </div>
    </Popover>
  );
};

export default SanjeevaniDepositeModal;
